import { RichTextContent } from "./RichTextContent";

interface ArticleBodyProps {
  markdown: string;
}

export function ArticleBody({ markdown }: ArticleBodyProps) {
  return (
    <div className="px-5 py-8 md:px-8">
      <div className="mx-auto max-w-[70ch]">
        <RichTextContent markdown={markdown} />
      </div>
    </div>
  );
}
